import { User } from './User';
import { Workspace } from './Workspace';
import { Team } from './Team';

export enum CustomFilterType {
    AUDIT_LOG = 'Audit Log',
    COMPANY = 'Company',
    DOCUMENT = 'Document',
    PEOPLE = 'People',
}

export enum CustomFilterVisibility {
    PRIVATE = 'Private',
    TEAM = 'Team',
    WORKSPACE = 'WORKSPACE',
    SHARED = 'Shared',
}


export interface CustomFilter {
  id: string;
  user: User;
  workspace: Workspace;
  team: Team;
  type: CustomFilterType | undefined;
  visibility: CustomFilterVisibility | undefined;
  title: string;
  description: string;
  favorited: boolean;
  query: any;
  createdAt: Date;
  updatedAt: Date;
}
